import { FunctionComponent, useContext, useEffect } from "react";

//OpenLayers
import { Draw } from "ol/interaction";

//Custom components
import MapContext from "@/components/Map/MapContext";
import { findInteraction, registerOlInteraction } from "@/lib/olHelpers";

//OL
import OlSourceVector from "ol/source/Vector";
import Geometry from "ol/geom/Geometry";
import OlStyle from "ol/style/Style";
import BaseEvent from "ol/events/Event";
import { DrawEvent } from "ol/interaction/Draw";
import OlFeature from "ol/Feature"

//Types
import { MapContextType } from "@/@types/context/MapContext";
;

export interface IDrawInteraction {
  source: OlSourceVector<OlFeature<Geometry>>
  type: "LineString" | "Polygon" | "Point"
  style: OlStyle
  onChange: (evt: BaseEvent) => void
  onDrawstart: (evt: DrawEvent) => void
  onDrawend: (evt: DrawEvent) => void

  active?: boolean

}

const DrawInteraction: FunctionComponent<IDrawInteraction> = (props) => {
  const context = useContext(MapContext) as MapContextType;

  const { type, active } = props;

  const options = {
    type: undefined,
    clickTolerance: undefined,
    features: undefined,
    source: undefined,
    dragVertexDelay: undefined,
    snapTolerance: undefined,
    stopClick: undefined,
    maxPoints: undefined,
    minPoints: undefined,
    finishCondition: undefined,
    style: undefined,
    geometryFunction: undefined,
    geometryName: undefined,
    condition: undefined,
    freehand: undefined,
    freehandCondition: undefined,
    wrapX: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    drawend: undefined,
    drawstart: undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(() =>
    registerOlInteraction(context, Draw, props, options, events)
    , [type])

  useEffect(() => {
    registerOlInteraction(context, Draw, props, options, events)

    if (context.map && active === false) {
      const int = findInteraction(context.map, Draw);
      if (int) {
        int.setActive(false);
      }
    }
  }, []);

  useEffect(() => {
    if (context.map && active !== undefined) {
      const int = findInteraction(context.map, Draw)
      if (int) {
        int.setActive(active);
      }
    }
  }, [active])

  return null;
};

export default DrawInteraction;

